const ViewIcon = (props:any) => {
  return (
    <svg
      id="View"
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34.001"
      viewBox="0 0 34 34.001"   
      {...props}
    >
      <path
        id="Union_7"
        data-name="Union 7"
        d="M-4841.553-364a4.448,4.448,0,0,1-4.447-4.449v-25.1a4.448,4.448,0,0,1,4.447-4.449h25.1a4.448,4.448,0,0,1,4.448,4.449v25.1a4.448,4.448,0,0,1-4.448,4.449Z"
        transform="translate(4846 398)"
        fill="#0260fa"
      />
      <g id="eye" transform="translate(7.009 -64.482)">
        <g
          id="Group_56589"
          data-name="Group 56589"
          transform="translate(0 74.667)"
        >
          <g id="Group_56588" data-name="Group 56588">
            <path
              id="Path_84653"
              data-name="Path 84653"
              d="M173.392,170.667a2.725,2.725,0,1,0,2.725,2.725A2.727,2.727,0,0,0,173.392,170.667Z"
              transform="translate(-163.401 -166.58)"
              fill="#fff"
            />
            <path
              id="Path_84654"
              data-name="Path 84654"
              d="M9.991,74.667A10.742,10.742,0,0,0,0,81.479a10.732,10.732,0,0,0,19.981,0A10.737,10.737,0,0,0,9.991,74.667Zm0,11.353a4.541,4.541,0,1,1,4.541-4.541A4.543,4.543,0,0,1,9.991,86.02Z"
              transform="translate(0 -74.667)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ViewIcon;
